import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

import { CheckCampaignName } from '../api/check-campaign-name';

export function useCheckCampaignName(name: string, enabled: boolean) {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();

  return useQuery({
    enabled: enabled && name.length > 0,
    queryKey: queryKeys.campaign.nameAvailability(name),
    queryFn: async ({ signal }) => await CheckCampaignName(workspaceId, name, signal),
    retry: false,
    staleTime: 30_000,
  });
}
